import { type FC } from 'react';

export const WhySgShieldCheckHeroIcon: FC = () => (
  <svg width={22} height={22} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M12 2.5 4.5 5.2v5.3c0 4.5 3.1 8.7 7.5 9.7 4.4-1 7.5-5.2 7.5-9.7V5.2L12 2.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="m9 12 2 2 4-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const WhySgShieldCheckSecurityCardIcon: FC = () => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M5.13335 11.4934C4.73782 9.71171 5.28078 7.8515 6.57264 6.56234C7.86449 5.27319 9.72584 4.73412 11.5067 5.13338C12.4868 3.60056 14.1806 2.6731 16 2.6731C17.8194 2.6731 19.5133 3.60056 20.4933 5.13338C22.277 4.73236 24.1418 5.27287 25.4345 6.56559C26.7272 7.8583 27.2677 9.72306 26.8667 11.5067C28.3995 12.4868 29.327 14.1807 29.327 16C29.327 17.8194 28.3995 19.5133 26.8667 20.4934C27.2659 22.2742 26.7269 24.1356 25.4377 25.4274C24.1486 26.7193 22.2884 27.2622 20.5067 26.8667C19.5278 28.4055 17.8305 29.3375 16.0067 29.3375C14.1829 29.3375 12.4856 28.4055 11.5067 26.8667C9.72584 27.266 7.86449 26.7269 6.57264 25.4378C5.28078 24.1486 4.73782 22.2884 5.13335 20.5067C3.58852 19.5291 2.6521 17.8283 2.6521 16C2.6521 14.1718 3.58852 12.471 5.13335 11.4934V11.4934"
      stroke="currentColor"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 15.9999L14.6667 18.6666L20 13.3333"
      stroke="currentColor"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhySgShieldCheckUptimeStatIcon: FC = () => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M26.6667 17.3333C26.6667 23.9999 22 27.3333 16.4534 29.2666C16.1629 29.365 15.8474 29.3603 15.56 29.2533C10 27.3333 5.33337 23.9999 5.33337 17.3333V7.99995C5.33337 7.26406 5.93082 6.66662 6.66671 6.66662C9.33337 6.66662 12.6667 5.06662 14.9867 3.03995C15.5703 2.54137 16.4298 2.54137 17.0134 3.03995C19.3467 5.07995 22.6667 6.66662 25.3334 6.66662C26.0693 6.66662 26.6667 7.26406 26.6667 7.99995V17.3333"
      stroke="currentColor"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 16.0002L14.6667 18.6668L20 13.3335"
      stroke="currentColor"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
